import { DOCUMENT } from '@angular/common';
import { GrupoService } from './../../../_core/services/grupo.service';
import { Component, Inject, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Page } from 'src/app/_core/models/page';
import { PageService } from 'src/app/_core/services/page.service';
import Swal from 'sweetalert2';
import { MovimentacaoService } from 'src/app/_core/services/movimentacao.service';
import { TelaDeRecebimentoModalComponent } from '../../tela-de-recebimento';

@Component({
  selector: 'app-grupo-recebimento',
  templateUrl: './grupo-recebimento.component.html',
  styleUrls: ['./grupo-recebimento.component.scss']
})
export class GrupoRecebimentoComponent implements OnInit {
  pagina = 1;
  total = 10;
  page: Page;
  ativo = true;
  pesquisa = '';
  loading = true;
  deletando = false;
  constructor(
    private pageService:PageService,
    private modalService:NgbModal,
    private grupoService:GrupoService,
    private movimentacaoService: MovimentacaoService,
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit(){
    this.ativo = true;
    this.page = new Page();
    this.page.currentPage = this.pagina;
    this.page.pageSize = this.total;
    this.page.ativo = this.ativo;
    this.page.currentPage = 1;
    this.setPage(this.page.currentPage);
  }
  refresh() {
    this.document.location.reload();
  }
  setPage(page:number){
    this.loading = true;
    this.page.currentPage = page;
    this.grupoService.listarMovPage(this.page)
    .subscribe(
      data => {
        this.page = data;
        this.page = this.pageService.getPager(this.page);
        this.loading = false;
        
      },
      err => {
        this.loading = false;
      })
  }
  paginaAtual(pagina:any) {
    return this.page.currentPage === pagina;
  }
  pesquisar() {
    this.page.pesquisa = this.pesquisa;
    this.page.ativo = this.ativo;
    this.page.dados = [];
    this.setPage(1);
  }
  atualizar() {
    this.pesquisa = '';
    this.ativo = true;
    this.page.dados = [];
    this.pesquisar();
  }
  receber(nR_BPM_BEM_PATRIMONIAL:number) {
      
    Swal.fire({
      title: 'Deseja receber esse bem?',
      confirmButtonText: 'Receber',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      icon: 'info',
    }).then((result)=>{
      if(result.value){
        this.movimentacaoService.insert_receber(nR_BPM_BEM_PATRIMONIAL).
        subscribe(
          (data) => {
            
            //console.log/"AQUI ==> ",data)
            const msg:string = 'Recebido com sucesso!'
            Swal.fire(
              'Sucesso!',
              msg,
              'success'
            ).then(() => {
              this.atualizar();
            });
          },
          (err) => {
            //console.log/JSON.stringify(err))
            let msg:string = 'Erro ao receber,tente novamente mais tarde!'
            if(err.status == 401){
              return msg = err.error;
            }
            Swal.fire('Erro',msg,'error').then(()=>{
              this.loading = false;
            });
          }
        )        
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        this.deletando = false;
        this.loading = false;
      }

    })
  }
  abreEdicao(nR_BPM_BEM_PATRIMONIAL:any){
    ////console.log/cD_BPM_BEM_PATRIMONIAL)
    const modalRef = this.modalService.open(TelaDeRecebimentoModalComponent, {
      size: 'lg',
      backdrop: 'static',
    });
    modalRef.componentInstance.nR_BPM_BEM_PATRIMONIAL = nR_BPM_BEM_PATRIMONIAL;
    modalRef.result.then(() => this.atualizar());
  }

}
